import { administratorRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { ticketHospitalityProductPageConfig } from "./ticketHospitalityProductPageConfig";

export const ticketHospitalityProductRecordDefinition: RecordDefinition = {
  path: "/ticket-hospitality-product",
  entityName: "dwtickethospitalityproduct",
  listRoute: "/ticket-hospitality-products",
  backTitle: "Back to ticket hospitality products",
  allowedRoles: administratorRoles,
  config: ticketHospitalityProductPageConfig,
  // The warehouse holds this record, and the view resolver never sees it.
  authorable: false,
  identity: {
    // Not a field on the page: GetPageData fills it from the warehouse's Name, the
    // product type, as the legacy page title did.
    titleFields: ["name"],
    fallbackTitle: "Ticket Hospitality Product",
    newRecordTitle: "New Ticket Hospitality Product",
  },
};
